import React, {useState, useEffect, useContext} from 'react';
import {Button, InputGroup, Input/*, Form*/} from 'reactstrap';
import {connect} from 'react-redux';
// import {getUsersForAlerts} from 'utils/api';
import {switchToOrganizationAccount, changeOrganizationName} from 'utils/api/settingsApi';
import {toast} from 'react-toastify';
//import { Link } from 'react-router-dom';
import {setPermissions} from 'redux/modules/auth/action';
import SpinnerButton from 'components/SpinnerButton';
import {ErrorContext} from 'contexts/ErrorContext';

//import momentTZ from 'moment-timezone';

function Details({auth, history, setPermissions, profile}) {
    const {handleErrors} = useContext(ErrorContext);

    const [orgName, setOrgName] = useState('');
    const [roleChangeLoading, setRoleChangeLoading] = useState(false);
    const [orgNameChangeLoading, setOrgNameChangeLoading] = useState(false);
    const [showSingleButton, setShowSingleButton] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setOrgName(auth.accountName);
        // getUsersList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const getUsersList = () => {
    //     getUsersForAlerts()
    //         .then((data) => {
    //             setShowSingleButton(data.content.length === 1);
    //         })
    //         .catch((err) => {
    //             if(err.message && err.message.length < 150) {
    //                 toast.error(err.message);
    //             }
    //             console.log(err);
    //         });
    // }

    const changeUserRole = () => {
        setRoleChangeLoading(true);
        switchToOrganizationAccount()
            .then((data) => {
                setPermissions();
                setRoleChangeLoading(false);
                toast.success(!auth.isSingleUser ? 'Switched to Single User mode' : 'Switched to Organizations mode');
            })
            .catch(err => {
                if(err.message && err.message.length < 150) {
                    toast.error(err.message);
                }
                setRoleChangeLoading(false);
            });
    };

    const changeOrgName = () => {
        setOrgNameChangeLoading(true);
        setError(null);
        const params = {
            accountName: orgName.trim(),
        };
        changeOrganizationName(params)
            .then((data) => {
                setOrgName(orgName.trim());
                setPermissions();
                toast.success('Organization name successfully changed');
                setOrgNameChangeLoading(false);
            })
            .catch(err => {
                // if(err.message && err.message.length < 150) {
                //     toast.error(err.message);
                // }
                setOrgNameChangeLoading(false);
                handleErrors(err, setError);
            });
    };

    const handlePressEnter = (e) => {
        if(e.key === 'Enter' && !orgNameChangeLoading) {
            changeOrgName();
        }
    };

    // const handleCsvDownload = async() => {
    //     try {
    //         await getCombinedCsvReport();
    //     } catch(err) {
    //         console.log(err);
    //         if(err.message && err.message.length < 150) {
    //             toast.error(err.message);
    //         }
    //     }
    // };

    // const checkConfirmPassword = (target, value) => {
    //     if (target === 'current') {
    //         handleCurrentError('');
    //         setCurrentPassword(value);
    //     } else {
    //         handleNewError('');
    //         setNewPassword(value);
    //     }
    // };

    // const resetPassword = async (e) => {
    //     e.preventDefault();
    //     if (newPassword.length < 6) {
    //         return handleNewError('The new password should be longer than 6 characters');
    //     }
    //     const params = {
    //         oldPassword: currentPassword,
    //         newPassword: {
    //             first: newPassword,
    //             second: newPassword,
    //         },
    //     };

    //     try {
    //         handlePasswordLoading(true);
    //         await resetOldPassword(params);
    //         toast.success('Password changed');
    //         changeMode(false);
    //         handlePasswordLoading(false);
    //     } catch (err) {
    //         handlePasswordLoading(false);
    //         handleCurrentError('Current password is incorrect');
    //         throw e;
    //     }
    // };

    return (
        <div className="account-card ">
            <div style={{height: '35px', marginBottom: '10px', display: 'flex', alignItems: 'center'}}>
                <h4>Account type: {auth.isSingleUser ? 'Single user' : 'Organization'}</h4>
            </div>
            {!auth.isSingleUser ?
                <>
                    {showSingleButton &&
                    <div style={{borderBottom: '1px solid lightgray', paddingBottom: '10px', marginBottom: '10px'}}>
                        <div>Switch your account to Single User Mode?</div>
                        <SpinnerButton
                            onClick={changeUserRole}
                            minWidth="300px"
                            title="Change Mode"
                            submitting={roleChangeLoading}
                            className="mt-2 mb-2"
                        />
                        {/*{!roleChangeLoading ?*/}
                        {/*    <div style={{*/}
                        {/*        width: '300px',*/}
                        {/*        height: '35px',*/}
                        {/*        display: 'flex',*/}
                        {/*        alignItems: 'center',*/}
                        {/*        justifyContent: 'center',*/}
                        {/*    }} className="mt-2 mb-2">*/}
                        {/*        <i className="fa fa-spinner fa-spin"/>*/}
                        {/*    </div>*/}
                        {/*    :*/}
                        {/*    <Button*/}
                        {/*        style={{minWidth: '300px'}}*/}
                        {/*        onClick={changeUserRole}*/}
                        {/*        className="calltoaction-button mt-2 mb-2"*/}
                        {/*    >*/}
                        {/*        Change Mode*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </div>
                    }
                    <div className="mb-1">Organization Name</div>
                    <InputGroup>
                        <div className="input-group-prepend">
                                <span style={{width: '40px'}} className="input-group-text">
                                    <i className="fas fa-building"/>
                                </span>
                        </div>
                        <Input
                            type="text"
                            placeholder="Full name"
                            value={orgName}
                            onKeyPress={(e) => handlePressEnter(e)}
                            onChange={(e) => setOrgName(e.target.value)}
                        />
                    </InputGroup>
                    {error && error.accountName && <div className="error-text">{error.accountName[0].message}</div>}
                    <div className="mt-3">
                        <SpinnerButton
                            onClick={changeOrgName}
                            className="calltoaction-button"
                            submitting={orgNameChangeLoading}
                            minWidth={'123.22px'}
                            title="Save Changes"
                            // disabled={!(orgName && orgName.trim() && orgName.trim() !== auth.accountName.trim())}
                        />
                    </div>
                    {/*<div style={{marginTop: '2rem'}}>*/}
                    {/*    <div>Combined CSV Report (Last 30 Days)</div>*/}
                    {/*    <Button*/}
                    {/*        onClick={handleCsvDownload}*/}
                    {/*        className="calltoaction-button mt-2"*/}
                    {/*    >*/}
                    {/*        <i className="fas fa-download"/>&nbsp;*/}
                    {/*        Download CSV*/}
                    {/*    </Button>*/}
                    {/*</div>*/}
                </>
                :
                <>
                    <div style={{borderBottom: '1px solid lightgray', paddingBottom: '10px'}}>
                        <div className="mb-2">Convert to Organizations account</div>
                        <div className="mb-2">
                            <SpinnerButton
                                title="Organizations Account"
                                submitting={roleChangeLoading}
                                minWidth="300px"
                                onClick={changeUserRole}
                            />
                        </div>

                        {/*{roleChangeLoading ?*/}
                        {/*    <div style={{*/}
                        {/*        width: '300px',*/}
                        {/*        height: '35px',*/}
                        {/*        display: 'flex',*/}
                        {/*        alignItems: 'center',*/}
                        {/*        justifyContent: 'center',*/}
                        {/*    }}>*/}
                        {/*        <i className="fa fa-spinner fa-spin"/>*/}
                        {/*    </div>*/}
                        {/*    :*/}
                        {/*    <Button*/}
                        {/*        style={{minWidth: '300px'}}*/}
                        {/*        onClick={changeUserRole}*/}
                        {/*        className="typical-button"*/}
                        {/*    >*/}
                        {/*        Organizations Account*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </div>
                    <div className="mt-2 d-flex align-items-center justify-content-between flex-nowrap"
                         style={{height: '35px'}}>
                        <h4>Email address</h4>
                        <b>{auth.username}</b>
                    </div>
                    {/* <div className="mt-2 d-flex flex-column align-items-center justify-content-between">
                        <div className="d-flex w-100 justify-content-between align-items-center">
                            <h4>Password</h4>
                            {resetPasswordMode ? (
                                <Button style={{ width: '100px' }} className="px-4 typical-button" onClick={() => changeMode(false)}>
                                    Cancel
                                </Button>
                            ) : (
                                <Button style={{ width: '100px' }} className="px-4 typical-button" onClick={() => changeMode(true)}>
                                    Reset
                                </Button>
                            )}
                        </div>
                        {resetPasswordMode && (
                            <Form onSubmit={resetPassword} className="w-100 mt-3">
                                <div className="password-container ">
                                    <div className="password-input">
                                        <h5 className="mb-1">Current password:</h5>
                                        <div>
                                            <Input
                                                style={{
                                                    borderColor: currentPasswordError ? 'red' : '#e4e7ea',
                                                }}
                                                type={!showOldPasword ? 'password' : 'text'}
                                                onChange={(e) => checkConfirmPassword('current', e.target.value)}
                                            />
                                            {showOldPasword ? (
                                                <i onClick={() => handleShowOldPassword(false)} className="ml-2 far fa-eye" />
                                            ) : (
                                                <i onClick={() => handleShowOldPassword(true)} className="ml-2 far fa-eye-slash" />
                                            )}
                                        </div>
                                        <span className="error-text">{currentPasswordError}</span>
                                    </div>
                                    <div className="password-input">
                                        <h5 className="mb-1">New password:</h5>
                                        <div>
                                            <Input
                                                style={{
                                                    borderColor: newPasswordError ? 'red' : '#e4e7ea',
                                                }}
                                                type={!showNewPassword ? 'password' : 'text'}
                                                onChange={(e) => checkConfirmPassword('new', e.target.value)}
                                            />
                                            {showNewPassword ? (
                                                <i onClick={() => handleShowNewPassword(false)} className="ml-2 far fa-eye" />
                                            ) : (
                                                <i onClick={() => handleShowNewPassword(true)} className="ml-2 far fa-eye-slash" />
                                            )}
                                        </div>
                                        <span className="error-text">{newPasswordError}</span>
                                    </div>
                                </div>
                                {passwordLoading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', width: '100px', marginTop: '10px' }}>
                                        <i className="fa fa-spinner fa-spin" />
                                    </div>
                                ) : (
                                    <Input
                                        disabled={!currentPassword || !newPassword || newPasswordError || currentPasswordError}
                                        style={{ width: '100px', marginTop: '10px' }}
                                        type="Submit"
                                        defaultValue="Confirm"
                                        className="btn typical-button"
                                    />
                                )}
                            </Form>
                        )}
                    </div> */}
                </>
            }
        </div>
    );
}

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, {setPermissions})(Details);
